import { render, staticRenderFns } from "./widgetMedico.vue?vue&type=template&id=6dc6638c&scoped=true"
import script from "./widgetMedico.vue?vue&type=script&lang=js"
export * from "./widgetMedico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc6638c",
  null
  
)

export default component.exports